<template>
  <a-spin :spinning="isLoading">
    <div class="leader-project-competencies">
      <h3>{{ title }}</h3>

      <div v-if="description" class="description">
        <p>{{ description }}</p>
      </div>

      <div class="competencies-list">
        <leader-competencies-card
          v-for="(item, index) in competencies"
          :key="item.title"
          :index="index"
          :title="item.title"
          :items="item.items"
        />
      </div>
    </div>
  </a-spin>
</template>

<script setup>
  import { onMounted, ref } from 'vue';
  import { useRoute } from 'vue-router';
  import { useApi } from '@/api/use-api';
  import {
    COMPETENCE_TYPE_SKILL,
    COMPETENCE_TYPE_SUBJECT,
    COMPETENCE_TYPE_TECHNOLOGY,
  } from '@/api/models/CompetenceType';
  import { CHECKPOINT_COMPETENCE_SET_STATUS_CONFIRMED } from '@/constants/checkpoint-competence-set';
  import LeaderCompetenciesCard from '@/views/leader/projects/competencies/LeaderCompetenciesCard.vue';

  const api = useApi();
  const route = useRoute();
  const competencies = ref([]);
  const isLoading = ref(true);

  defineProps({
    title: String,
    description: String,
  });

  onMounted(async () => {
    await getStats();
    isLoading.value = false;
  });

  const getStats = async () => {
    try {
      const response = await api.competence.projectStats(
        new URLSearchParams({
          projectId: route.params.id,
          status: CHECKPOINT_COMPETENCE_SET_STATUS_CONFIRMED,
          'per-page': 100,
        })
      );

      competencies.value = [
        {
          title: 'Предметная область',
          items: response.competencies.items.filter(
            (el) => el.type === COMPETENCE_TYPE_SUBJECT
          ),
        },
        {
          title: 'Технологии',
          items: response.competencies.items.filter(
            (el) => el.type === COMPETENCE_TYPE_TECHNOLOGY
          ),
        },
        {
          title: 'Навыки',
          items: response.competencies.items.filter(
            (el) => el.type === COMPETENCE_TYPE_SKILL
          ),
        },
      ];
    } catch (error) {
      console.error('error', error);
    }
  };

  defineExpose({ getStats });
</script>

<style lang="scss" scoped>
  @use "@/assets/styles/_colors.scss" as *;

  .leader-project-competencies {
    margin-top: 10px;
    max-width: 902px;

    h3 {
      font-size: 18px;
      margin-bottom: 10px;
    }

    h4 {
      font-size: 14px;
      margin: 30px 0 6px;

      &.disabled {
        color: $color-text-primary !important;
      }
    }

    .description {
      color: $color-text-primary;
      display: flex;
      flex-direction: column;
      font-family: 'Nunito Sans', sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      gap: 18px;
      line-height: 20px;
      max-width: 678px;
    }
  }
</style>
